import { render, staticRenderFns } from "./FourthSection.vue?vue&type=template&id=29b38298&"
import script from "./FourthSection.vue?vue&type=script&lang=ts&"
export * from "./FourthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports